export const MAIN_PAGE_NAME = 'Help & Support';
export const SEARCH_DOCUMENTATION_SECTION_NAME = 'Search Documentation';
export const RELEASE_NOTES_NAME = 'Release Notes';

export const BUTTONS_IN_SECTION = 2;
export const GETTING_STARTED_SECTION_NAME = 'Getting Started';
export const PAGE_HELP_SECTION_NAME = 'Help for This Page';
export const ADDITIONAL_RESOURCES_SECTION_NAME = 'Additional Resources';
export const RELEASE_NOTES_SECTION_NAME = 'Release Notes';

export const SEARCH_TIMEOUT_DELAY = 1000;
